<div class="container-fluid">

  <div class="row s-contentheader">
    <div class="col-md-12">
      <div>
        <h2 class="text-center" *ngIf="parentProductName === ''">{{customLabel('STAGES', 'menuSES')}} <i>({{nbStage}})</i></h2>
        <h2 class="text-center" *ngIf="parentProductName !== ''">Sessions associées au produit <strong>({{parentProductName}})</strong></h2>
        <div class="s-dividerx"></div>
        <p></p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-3">


      <div class="card p-4 mb-3 s-listfilter" *ngIf="parentProductName === ''">
        <h5 class="font-weight-bold">{{'filterLST'|localize}}</h5>

        <div class="w-100 py-5 text-center" *ngIf="splashFilter">
          <div class="fa-2x">
            <i class="fas fa-spinner fa-spin greenrdb"></i>
          </div>
        </div>

        <div *ngIf="!splashFilter">
          <div>
            <a (click)="getAllSession()" class="ispointer"><i class="fa fa-asterisk"></i>{{'allstages'|localize}}</a>
          </div>

          <div *ngFor="let y of yearList;let i = index">
            <a data-toggle="collapse" href="#collapse{{i}}" title="{{'filterSDT'|localize}} {{y.Year}}">
              <i class="fa fa-chevron-right"></i>{{y.Year}}
            </a>
            <div id="collapse{{i}}" class="panel-collapse collapse">
              <div class="mt-2 ml-5" *ngFor="let m of y.MonthsList | sortlist">
                <a (click)="getStagesByDate(y.Year, m.MonthsNumber)"><i class="fa fa-filter"></i>{{m.MonthDef}}</a>
              </div>
            </div>
          </div>

          <div class="mt-2">
            <a data-toggle="collapse" href="#collapseADRS" title="Adresses des stages">
              <i class="fa fa-chevron-right"></i>Lieu de la session
            </a>
            <div id="collapseADRS" class="panel-collapse collapse">
              <div class="mt-2 ml-5" *ngFor="let ad of addresses;let i = index">
                <a (click)="getStagesByAddress(ad)"><i class="fa fa-filter"></i>{{ad.FormatADR}}</a>
              </div>
            </div>
          </div>

          <div *ngFor="let c of catalogs;">
            <a data-toggle="collapse" href="#collapse{{c.Ident}}" title="{{'filterCCP'|localize}}">
              <i class="fa fa-chevron-right"></i>{{c.Name_CTL}}
            </a>
            <div id="collapse{{c.Ident}}" class="panel-collapse collapse">
              <div class="mt-2 ml-5" *ngFor="let ct of c.ListCategory">
                <a data-toggle="collapse" href="#collapse{{ct.Ident}}"><i class="fa fa-chevron-right"></i>{{ct.Nom__CAT}}</a>
                <i class="fas fa-search ml-2" (click)="getStagesByCategorie(ct)"></i>
                <div id="collapse{{ct.Ident}}" class="panel-collapse collapse">
                  <div class="mt-2 ml-5" *ngFor="let s of ct.ListProd">
                    <a (click)="getStagesByProduct(s)" title="tot stages: {{s.ListStages.length}}"><i class="fa fa-filter"></i>{{s.DescProduct}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-md-7">

      <div class="container-fluid" *ngIf="splashStage">
        <div class="row mt-5">
          <div class="col-12 text-center">
            <div class="fa-3x mt-5">
              <i class="fas fa-spinner fa-spin greenrdb"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid" *ngIf="!splashStage">
        <div class="row s-listcontent" *ngFor="let stage of stagesFilteredOPT">
          <div class="col-md-6" *ngFor="let s of stage.listFils">
            <div class="card s-listcard ispointer" (click)="getCurrentStage(s)">
              <div class="row no-gutters">
                <div class="col-auto">
                  <div class="s-listcardborder">&nbsp;</div>
                  <!--<img src="images/test3.png" class="s-imgfluid" alt="" />-->
                </div>
                <div class="col">
                  <div class="card-block px-2 s-listcardblock">
                    <h5 [title]="s.Ident">{{s.Info_PRO}}</h5>
                    <h6><i class="fa fa-calendar"></i> {{'from'|localize}} {{s.DatedPro}} {{'to'|localize}} {{s.DatefPro}}</h6>
                    <h6 *ngIf="s.AddressesList && s.AddressesList.length > 0"><i class="fa fa-map-marker-alt"></i> {{s.AddressesList[0].FormatADR}}</h6>
                    <p title="{{formatTooltip(s.PartiPRO)}}">{{formatContent(s.PartiPRO)}}</p>
                  </div>
                </div>
              </div>

              <div class="s-listcardfooter">
                <a (click)="getCurrentStage(s)" class="float-right mr-4"><i class="fa fa-search"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <button type="button" class="btn s-btncircle btn-lg s-btnbottom" (click)="store.openPage('/home/base')">
        <i class="fa fa-arrow-left 2x"></i>
      </button>
    </div>
  </div>

</div>
